// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"725":"56157381","943":"8586fac0"}[chunkId] + ".chunk.css";
};